export const AUTH_TOKEN: string = "auth-token";
export const AUTH_USER_PROFILE: string = "auth_user_profile";
export const SYSTEM_SETTING: string = "system_setting";
